<template>
    <div class="add-appointment-dialog">
        <el-dialog
            :visible.sync="visible"
            :title="$t('Course.add')"
            left>
            <!-- :placeholder="$t('Reception.Fifth.place_name_phone') -->
            <div v-if="step == 1">
                <!-- 远程搜索 -->
                <el-select
                    style="width: 100%;"
                    class="mb-10"
                    v-model="form.userId"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入客户姓名，手机，卡号"
                    :remote-method="fetchUser"
                    v-on:change="fetchUserInfo">
                    <el-option
                        v-for="item in users"
                        :key="item.id"
                        :label="item.resultText"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div v-if="step == 2">
                <div class="add-appoint-user">
                    <div class="flex appoint-user-info">
                        <div class="appoint-user-item">
                            {{ $t('Common.name') }}：{{ userInfo.clientName }}
                        </div>
                        <div class="appoint-user-item">
                            {{ $t('Common.phone') }}：{{ userInfo.clientPhone }}
                        </div>
                    </div>
                    <div class="appoint-user-item">
                        {{ $t('Common.card_number') }}：{{ userInfo.cardNum }}
                    </div>
                    <div class="appoint-user-item">
                        {{ $t('Common.member_card_number') }}：{{ userInfo.cardName }}
                    </div>
                    <div>{{ $t('Member.end') }}：{{ userInfo.mshpExpiredAt }}</div>
                </div>
                <div
                    v-if="!userInfo.cards.length && userInfo.charge"
                    class="add-appoint-tips"
                >{{ $t('Card.cant_pay') }}</div>
                <div
                    v-if="userInfo.cards.length && userInfo.charge"
                    class="add-appoint-tips">
                    <div>{{ $t('Card.choose_pay') }}</div>
                    <div class="mt-4 add-appoint-radio">
                        <el-radio
                            v-for="(item, index) in cards"
                            :key="index"
                            v-model="form.cardId"
                            :label="item.contractNum">
                            {{ `${item.contractNum}（${$t('Card.amt')}：
                            ${item.cardBalance}）${$t('Card.pay')}：
                            ${item.rate}${$t('Reception.Fifth.yuan')}` }}
                        </el-radio>
                    </div>
                </div>
            </div>

            <span v-if="step == 2" slot="footer" class="dialog-footer">
                <el-button @click="step = 1">{{ $t('Common.close') }}</el-button>
                <el-button
                    @click="confirm"
                    type="primary"
                >{{ $t('Common.submit') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog, Radio } from 'element-ui';

export default {
    name: 'add-appoint',
    components: {
        ElDialog: Dialog,
        ElRadio: Radio,
    },
    data() {
        return {
            visible: false,
            form: {
                userId: null,
                cardId: 0,
            },
            // 当前课时的id
            id: null,
            // 筛选
            users: [],
            step: 1,
            // 选择后获取的用户信息
            userInfo: {},
            rules: {
                name: { type: 'string', required: true },
                time: { type: 'string', required: true },
                storeId: { type: 'number', required: true },
                coachId: { type: 'number', required: true },
                placeId: { type: 'number', required: true },
                limit: { type: 'string', required: true },
            },
            select: {
                stores: [],
                places: [],
                coachs: [],
            },
            searchText: null,
            cards: [],
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.select.coachs;
            const arr = this.select.coachs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: null, nickname: this.$t('Common.data_not_found')}];
        },
    },
    methods: {
        resetForm() {
            this.step = 1;
            this.userInfo = {};
            this.users = [];
        },
        async open(id) {
            this.id = id;
            this.visible = true;
        },
        // 远程搜索用户
        fetchUser(val = '') {
            API.get('client/search', {
                params: {
                    keyword: val,
                },
            }).then(res => {
                this.users = res;
            });
        },
        // 获取用户详细信息
        fetchUserInfo() {
            const query = {
                clientId: this.form.userId,
                scheduleId: this.id,
            };
            API.get('lesson/team/schedule/reserve/client', {
                params: query,
            }).then(res => {
                this.cards = res.cards;
                this.userInfo = res;
                this.step = 2;
                // 清空第一步
                this.form.userId = null;
                this.users = [];
            });
        },
        confirm() {
            // 付费与否 & 存在有效期会籍合同
            if (this.userInfo.charge && !this.cards.length) {
                return $ele.$message(this.$t('Card.please_choose'));
            }

            const query = {
                clientId: this.userInfo.clientId,
                // 付费则传入储值卡号
                contractNum: this.form.cardId ? this.form.cardId : null,
                scheduleId: this.id,
            };
            API.post(`lesson/team/schedule/${this.id}/reserve`, query).then(() => {
                $ele.$message.success(this.$t('Card.appoint_success'));
                this.$emit('fetchItem');
                this.visible = false;
            });
        },
    },
};
</script>

<style lang="scss">
.add-appointment-dialog {
    .el-dialog {
        width: 500px;
        max-height: 480px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
.el-dialog--center .el-dialog__body {
    padding: 25px 25px 0;
}
.add-appoint-user {
    font-size: 12px;
    border: 1px solid #e6e6e6;
    padding: 20px 10px;
    background: #f7f7f7;
}
.add-appoint-tips {
    font-size: 12px;
    margin-top: 20px;
}
.appoint-user-item {
    margin-bottom: 20px;
}
.appoint-user-info {
    div {
        width: 50%;
    }
}
.add-appoint-radio {
    .el-radio__label {
        font-size: 12px;
    }
}
</style>
